import React from 'react';
import { Route } from 'react-router-dom';
import { SparkApp } from 'spark-core-dx';
import { StandardLayout } from 'spark-core-dx/components';
import { DomainRoute } from 'spark-core-dx/domains';
import Home from './domains/public/screens/Home';
import DashboardDomain from './domains/dashboard/DashboardDomain';
import Dashboard from './domains/dashboard/screens/Dashboard';
import DashboardSelect from './domains/dashboard/screens/DashboardSelect';
import DataDomain from './domains/data/DataDomain';
import DataModelWorkspaceSelect from './domains/data/screens/DataModelWorkspaceSelect';
import DataModelDesigner from './domains/data/screens/DataModelDesigner';
import ReportsDomain from './domains/reports/ReportsDomain';
import Reports from './domains/reports/screens/Reports';
import LandingDomain from './domains/landing/LandingDomain';
import Landing from './domains/landing/screens/Landing';
import { useCoreRoute } from 'spark-core-dx/hooks';
import PublicDomain from './domains/public/PublicDomain'
import SearchSourceObject from './domains/convoke/screens/SearchSourceObject';
import SearchEntityObject from './domains/convoke/screens/SearchEntityObject';
import SearchWarehouse from './domains/convoke/screens/SearchWarehouse';
import ConvokeDomain from './domains/convoke/ConvokeDomain';
import EntityObjectFieldMapping from './domains/convoke/screens/EntityObjectFieldMapping';
import ReportCard from './domains/reports/screens/ReportCard';
import XChatDomain from './domains/multiverXChat/xChatDomain';
import XChat from './domains/multiverXChat/screens/xchat'
import EngineConsoleScreen from './domains/dashboard/screens/EngineConsoleScreen';
import PermissionSetManage from './domains/convoke/screens/PermissionSetManage';
import SourceColumnSetManage from './domains/convoke/screens/SourceColumnSetManage';
import EntityFieldMapDesignerManage from './domains/convoke/screens/EntityFieldMapDesignerManage';
import MigrationProjectManage from './domains/convoke/screens/MigrationProjectManage';
import EDIDiagnosticsManage from './domains/convoke/screens/EDIDiagnosticsManage';
import Status from './domains/status/screens/Status';
import BatchManagement from './domains/convoke/screens/BatchManagement';
import BillingManagement from './domains/convoke/screens/BillingManagement';
import AIPanelCommandHost from './components/AIChat/AIPanelCommandHost';

const App = () => {

  const { getRoute } = useCoreRoute()

  // Reserved /login /logout /admin/* 
  return (
    <>
      <SparkApp
        staticContentRoutes={[
          '/',
        ]}
        addonRoutes={[
        <Route key={"Home"} element={<DomainRoute component={PublicDomain} />} > {/* Domain */}
          <Route exact path={'/'} element={<Home />} /> {/* Screens */}
        </Route>,
        <Route element={<DomainRoute component={ReportsDomain} domainName={'Reports'} />} >
          <Route path={getRoute("/reports/", "Reports")} element={<Reports />} /> {/* Screens */}
          <Route path={getRoute("/reports/", "Reports") + '/:id'} element={<ReportCard />} /> {/* Screens */}
        </Route>,
        <Route key={"Convoke1"} element={<DomainRoute component={ConvokeDomain} domainName={'Convoke'} />} >
          <Route path={getRoute("/convoke/sosearch/", "Convoke") + "/:soId"} element={<SearchSourceObject />} /> {/* Screens */}
        </Route>,
        <Route key={"Convoke2"} element={<DomainRoute component={ConvokeDomain} domainName={'Convoke'} />} >
         <Route path={getRoute("/convoke/eosearch/", "Convoke") + "/:eoId"} element={<SearchEntityObject />} /> {/* Screens */}
        </Route>,
        <Route key={"Convoke2b"} element={<DomainRoute component={ConvokeDomain} domainName={'Convoke'} />} >
         <Route path={getRoute("/convoke/whsearch/", "Convoke") + "/:wId"} element={<SearchWarehouse />} /> {/* Screens */}
        </Route>,
        <Route key={"Convoke3"} element={<DomainRoute component={ConvokeDomain} domainName={'Convoke'} />} >
          <Route path={getRoute("/convoke/eofieldmapping/", "Convoke") + "/:eoId"} element={<EntityObjectFieldMapping />} /> {/* Screens */}
        </Route>,
        <Route key={"Convoke4"} element={<DomainRoute component={ConvokeDomain} domainName={'Convoke'} />} >
          <Route path={getRoute("/permissionset/manage/", "Convoke") + "/:id"} element={<PermissionSetManage />} /> {/* Screens */}
        </Route>,
        <Route key={"Convoke5"} element={<DomainRoute component={ConvokeDomain} domainName={'Convoke'} />} >
          <Route path={getRoute("/sourceobject/manage/", "Convoke") + "/:id"} element={<SourceColumnSetManage />} /> {/* Screens */}
        </Route>,
        <Route key={"Convoke6"} element={<DomainRoute component={ConvokeDomain} domainName={'Convoke'} />} >
          <Route path={getRoute("/entityobject/manage/", "Convoke") + "/:eoId"} element={<EntityFieldMapDesignerManage />} /> {/* Screens */}
        </Route>,
        <Route key={"Convoke7"} element={<DomainRoute component={ConvokeDomain} domainName={'Convoke'} />} >
          <Route path={getRoute("/batchmanagement/manage/", "Convoke")} element={<BatchManagement />} />
        </Route>,
        <Route key={"Convoke8"} element={<DomainRoute component={ConvokeDomain} domainName={'Convoke'} />} >
          <Route path={getRoute("/billing/manage/", "Convoke")} element={<BillingManagement />} />
        </Route>,
        <Route key={"Convoke9"} element={<DomainRoute component={ConvokeDomain} domainName={'Convoke'} />} >
          <Route path={`${getRoute("/migration/manage/", "Convoke") ?? "/DataManagement/Migration/Manage"}/:migrationProjectId`} element={<MigrationProjectManage />} />
        </Route>,
        <Route key={"Convoke10"} element={<DomainRoute component={ConvokeDomain} domainName={'Convoke'} />} >
          <Route path={`${getRoute("/edi/diagnostics/", "Convoke") ?? "/edi/diagnostics"}/:sourceObjectId`} element={<EDIDiagnosticsManage />} />
        </Route>,
        <Route element={<DomainRoute component={DataDomain} domainName={'Convoke'} />} >
          <Route path={`${getRoute("/model-workspaces/")?.RoutePath ?? '/model-workspaces'}`} element={<DataModelWorkspaceSelect />} />
          <Route path={`${getRoute("/model-workspaces/")?.RoutePath ?? '/model-workspaces'}/:workspaceId`} element={<DataModelDesigner />} />
          <Route path={`${getRoute("/model-workspaces/")?.RoutePath ?? '/model-workspaces'}/:workspaceId/models/new`} element={<DataModelDesigner createMode />} />
          <Route path={`${getRoute("/model-workspaces/")?.RoutePath ?? '/model-workspaces'}/:workspaceId/models/:dataModelId`} element={<DataModelDesigner />} />
        </Route>,
        <Route element={<DomainRoute component={DataDomain} domainName={'Dynamic'} />} >
          <Route path={`${getRoute("/dynamic/datamodelworkspace/")?.RoutePath ?? '/dynamic/datamodelworkspace'}`} element={<DataModelWorkspaceSelect />} />
          <Route path={`${getRoute("/dynamic/datamodelworkspace/")?.RoutePath ?? '/dynamic/datamodelworkspace'}/:workspaceId`} element={<DataModelDesigner />} />
          <Route path={`${getRoute("/dynamic/datamodelworkspace/")?.RoutePath ?? '/dynamic/datamodelworkspace'}/:workspaceId/models/new`} element={<DataModelDesigner createMode />} />
          <Route path={`${getRoute("/dynamic/datamodelworkspace/")?.RoutePath ?? '/dynamic/datamodelworkspace'}/:workspaceId/models/:dataModelId`} element={<DataModelDesigner />} />
        </Route>,
        <Route element={<DomainRoute domainName={'Dashboard'} component={DashboardDomain} />} >
          <Route path={`${getRoute("/dashboard/model/")?.RoutePath ?? '/dashboard/model'}/:dashboardId`} element={<DataModelDesigner dashboardMode />} />
          <Route path={`${getRoute("/dashboard/")?.RoutePath ?? '/dashboard'}`} element={<DashboardSelect />} />
          <Route path={`${getRoute("/dashboard/")?.RoutePath ?? '/dashboard'}/:dashboardId`} element={<Dashboard />} />
          <Route path={`${getRoute("/dashboard/")?.RoutePath ?? '/dashboard'}/:dashboardId/page/:pageId`} element={<Dashboard />} />
         </Route>,
          <Route element={<DomainRoute domainName={'Dashboard'} component={DashboardDomain} />} >
          <Route path={`${getRoute("/dashboard/engineConsole")?.RoutePath ?? '/dashboard/engineConsole'}`} element={<EngineConsoleScreen />} />
         </Route>,
        <Route key={"XChat"} element={<DomainRoute component={XChatDomain} domainName={'XChat'} />} >
          <Route path={getRoute("/multiverx/chat/", "XChat")} element={<XChat />} /> {/* Screens */}
        </Route>,
        <Route key={"AuthorizedHome"} element={<DomainRoute key={'AuthorizedHome'} domainName={'AuthorizedHome'} component={LandingDomain} />} >
          <Route path={getRoute('/landing/', "AuthorizedHome")} element={<Landing />} />
        </Route>,
        <Route key={"Status"} path="/status" element={
          <StandardLayout>
            <Status />
          </StandardLayout>
        } />
        ]} />
      <AIPanelCommandHost />
    </>
  )
}

export default App;
